import { Routes } from '@angular/router';
import { accountGuard, authGuard } from '@webapp/auth/guards';
import { GlobalErrorComponent } from '@webapp/core/ui/components/global-error/global-error-page.component';
import { QUOTER_ROUTE_SEGMENT } from '@webapp/core';

export const routes: Routes = [
	/*{
		path: 'test',
		component: TestTransportComponent
	},*/
	{
		path: '',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/dashboard').then(
				m => m.DASHBOARD_ROUTES
			),
	},
	{
		path: 'ingresar',
		canActivate: [accountGuard],
		loadChildren: () =>
			import('@webapp/auth/routes').then(
				m => m.loginRoutes
			),
	},
	{
		path: 'registro',
		canActivate: [accountGuard],
		loadChildren: () =>
			import('@webapp/auth/routes').then(
				m => m.registerRoutes
			),
	},
	{
		path: 'cuenta',
		loadChildren: () =>
			import('@webapp/auth/routes').then(
				m => m.authenticationRoutes
			),
	},
	{
		path: QUOTER_ROUTE_SEGMENT,
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/quoter').then(
				m => m.routes
			),
	},
	{
		path: 'cotizaciones',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/quotes').then(
				m => m.routes
			),
	},
	{
		path: 'usuarios',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/users').then(
				m => m.routes
			),
	},
	{
		path: 'prospectos',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/prospects').then(
				m => m.routes
			),
	},
	{
		path: 'polizas',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/policies').then(
				m => m.routes
			),
	},
	{
		path: 'qrs',
		loadChildren: () =>
			import('@webapp/qrs').then(
				m => m.routes
			),
	},
	{
		path: 'inspecciones',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/inspections').then(
				m => m.routes
			),
	},
	{
		path: 'administracion',
		canActivate: [authGuard],
		loadChildren: () =>
			import('@webapp/administration').then(m => m.routes),
	},
	{
		path: 'error',
		canActivate: [authGuard],
		component: GlobalErrorComponent
	},

];
